// extracted by mini-css-extract-plugin
export default {"loader":"SpinLoader_loader__cMotB","rotation":"SpinLoader_rotation__zINCD","spinLoader":"SpinLoader_spinLoader__6Jyik"};